angular.module("app.version", [])
.constant("VersionInfo", {"version":"2.6.0","timestamp":"2025-08-11T10:27:07Z","revision":"236635f","nickname":"hospitable-skirt","env":"generic"});
